import './HeroSection.css';

export default function HeroSection() {
  return (
    <section className="hero">
      <div className="hero__bg" style={{ backgroundImage: 'url(/hero-bg.png)' }} />
      <div className="hero__grad-1" />
      <div className="hero__grad-2" />

      <div className="hero__container">
        <p className="hero__label">
          <span className="hero__label-icon">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path d="M10.5 0L12.47 8.53L21 10.5L12.47 12.47L10.5 21L8.53 12.47L0 10.5L8.53 8.53L10.5 0Z" fill="#99FE00"/>
            </svg>
          </span>
          The complete payouts platform
        </p>

        <h1 className="hero__heading">
          {'Payouts that settle in seconds.\nReconciliation that runs itself.'}
        </h1>

        <p className="hero__body">
          Send, schedule and track every payout from one platform. Reconciliation
          happens automatically, and the ledger always balances.
        </p>

        <div className="hero__actions">
          <a href="#contact" className="hero__btn hero__btn--primary">
            Book a discovery call
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M2 7.5H13M13 7.5L8.625 3.125M13 7.5L8.625 11.875" stroke="#06122E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a href="#about" className="hero__btn hero__btn--secondary">
            See what we do
          </a>
        </div>

        <p className="hero__footnote">Typical response: 1 business day</p>
      </div>
    </section>
  );
}
